// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-wrapper{margin:0 auto;background-color:#ededed}.app-wrapper.pc{filter:drop-shadow(0 0 .25rem rgba(0,0,0,.3));width:18.75rem;height:32.5rem;border-radius:.375rem;overflow-x:hidden;overflow-y:auto}.app-wrapper.pc::-webkit-scrollbar{width:.25rem;height:.25rem}.app-wrapper.pc::-webkit-scrollbar-thumb{border-radius:.125rem;background-color:rgba(0,0,0,.2)}.app-wrapper:not(.pc){width:100%;height:100%;min-height:100%}", ""]);
// Exports
module.exports = exports;
